// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-debit-option--CVFtt{font-size:13px}.edit-toggle-btn--kaNwy{font-size:13px;text-decoration:none}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/RightPanel/Billing/DirectDebit/components/custom-toggle-title.module.scss"],"names":[],"mappings":"AAAA,8BACE,cAAA,CAGF,wBACE,cAAA,CACA,oBAAA","sourcesContent":[".selected-debit-option {\n  font-size: 13px;\n}\n\n.edit-toggle-btn {\n  font-size: 13px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selected-debit-option": "selected-debit-option--CVFtt",
	"edit-toggle-btn": "edit-toggle-btn--kaNwy"
};
export default ___CSS_LOADER_EXPORT___;
